import { render, staticRenderFns } from "./GallerySlideshow.vue?vue&type=template&id=a8ac3bee&scoped=true"
import script from "./GallerySlideshow.vue?vue&type=script&lang=js"
export * from "./GallerySlideshow.vue?vue&type=script&lang=js"
import style0 from "./GallerySlideshow.vue?vue&type=style&index=0&id=a8ac3bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac3bee",
  null
  
)

export default component.exports